// Plan ▸ Cast & Places: characters, places, objects and motifs, and their details.
export { CastPage as component } from '../../views/story/CastPage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'cast';
export const title = 'Cast & Places';
export const help = 'story-view';
export const columnTitle = 'People';
